import { Component, OnInit, Inject, Input } from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { GrowerOrderService } from './../../../../../services/seed/growerOrder.service';
import { LoaderService } from './../../../../../services/infrastructure/loader.service';
import { LocalStorageService } from './../../../../../services/infrastructure/local-storage.service';
import { MasterConstants } from '../../../../../common/constants/master-constants';
import { CommonService } from '../../../../../services/common/common.service';
import { Subscription } from 'rxjs';
import { DatePipe } from '@angular/common';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { MobilePDFVM } from '../../../../../models/CPP/MobilePDFVM';
pdfMake.vfs = pdfFonts.pdfMake.vfs;

@Component({
  selector: 'app-growerGeneratePdf',
  templateUrl: './grower-pdf-generate.component.html',
  styleUrls: ['./grower-pdf-generate.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0', display: 'none' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
    trigger('fadeInOut', [
      transition(':enter', [   // :enter is alias to 'void => *'
        style({ opacity: 0 }),
        animate(400, style({ height: '*', opacity: 1 }))
      ]),
      transition(':leave', [   // :leave is alias to '* => void'
        animate(400, style({ height: '0px', opacity: 0 }))
      ])
    ])
  ]
})

export class GrowerPdfGenerate implements OnInit {
  pdfDataObject: any;
  subscription = new Subscription();
  isMobile = /Android|iPhone/i.test(window.navigator.userAgent);
  basePdfData: string;
  orderPdf: any;
  headerYear: string;
  mobilePdf: MobilePDFVM = new MobilePDFVM();

  @Input() growerId: string;

  constructor(private growerOrderService: GrowerOrderService,
    private localStorageService: LocalStorageService,
    private loaderService: LoaderService,
    public commonService: CommonService,
    private datePipe: DatePipe,
    @Inject('BASE_URL') public baseUrl: any) {
  }

  // Data call on InIT
  ngOnInit(): void {
    if (this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR)) {
      this.headerYear = JSON.parse(this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR));
    }
  }

  generatePdf() {
    this.loaderService.setLoaderStatus(true);
    const self = this;
    this.subscription.add(this.growerOrderService.getGrowerPDFdata(this.headerYear, this.growerId).subscribe((result) => {
      if (result) {
        self.orderPdf = result;
        this.pdfDataObject = result;
        const documentDefinition = this.getDocumentDefinition();
        if (this.isMobile) {
          const pdfDocGenerator = pdfMake.createPdf(documentDefinition);
          pdfDocGenerator.getBase64((data) => {
            this.basePdfData = data;
            const currentDateTime = new Date();
            this.mobilePdf = {
              MobilePDFBase64: this.basePdfData,
              FileName: 'GrowerOrder_' + this.pdfDataObject.headerDetails[0].orderID + '_' + currentDateTime.getDate() + (currentDateTime.getMonth() + 1) + currentDateTime.getFullYear() + '_' + currentDateTime.getHours() + currentDateTime.getMinutes() + currentDateTime.getSeconds() + '.pdf'
            };
            this.subscription.add(this.growerOrderService.sendBaseDate(this.mobilePdf).subscribe((result) => {
              window.location.assign(result.filePath);
              this.loaderService.setLoaderStatus(false);
            }, error => this.loaderService.setLoaderStatus(false)));
          });
        }
        else {
          pdfMake.createPdf(documentDefinition).download('GrowerOrder_' + this.pdfDataObject.headerDetails[0].orderID + this.commonService.GetTimeForFileName() + '.pdf');
        }
        this.loaderService.setLoaderStatus(false);
      }
    }, error => {
      this.loaderService.setLoaderStatus(false);
    }));
  }

  getDocumentDefinition() {
    const dt = new Date();
    const currDate = this.datePipe.transform(dt, 'MM/dd/yyyy');
    const orderCreateDate = this.pdfDataObject.headerDetails[0].createdOnString;
    let displayWith = [];
    let columnList = [];
    let valueList = [];
    let bulkdetailsheader;
    bulkdetailsheader = {
      body: [
        ['GROWER ORDER NUMBER:', this.pdfDataObject.headerDetails[0].orderID],
        ['CREATED:', this.datePipe.transform(this.pdfDataObject.headerDetails[0].orderDate, 'MM/dd/yyyy')],
        ['GROWER:', this.pdfDataObject.headerDetails[0].gmk + " " + this.pdfDataObject.headerDetails[0].growerName + "," + this.pdfDataObject.headerDetails[0].growerAddress],
        ['ACCOUNT NAME:', this.pdfDataObject.headerDetails[0].shipToAccount + "-" + this.pdfDataObject.headerDetails[0].shipToAccountName],
        ['ADDRESS:', this.pdfDataObject.headerDetails[0].shipToAddress1 + "," + this.pdfDataObject.headerDetails[0].shipToCity + "-" + this.pdfDataObject.headerDetails[0].shipToState + "," + this.pdfDataObject.headerDetails[0].shipToZip]
      ]
    };


    const pdfHTML = {
      footer: function (currentPage, pageCount, pageSize) {
        return [
          { text: currDate, alignment: 'left', fontSize: 8, style: 'pageText', marginLeft: 45 },
          { text: 'Page' + currentPage.toString() + ' of ' + pageCount, alignment: 'right', style: 'pageText', fontSize: 8, marginRight: 45 },
        ];
      },
      content: [
        {
          image: 'data:image/png;base64,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',
          width: 102,
          height: 37,
          alignment: 'left',
        },
        {
          layout: 'noBorders',
          table: bulkdetailsheader,
          style: 'pageText',
          fontSize: 8,
          marginTop: 10
        },
        {
          table: {
            widths: displayWith,
            headerRows: 1,
            fontSize: 5,
            body: [
              columnList,
              valueList,
            ]
          },
          marginTop: 10,
          fontSize: 8,
          style: 'pageText',
          layout: 'noBorders',
        },
        this.getContractPdfObject(this.pdfDataObject.growerOrderItems),
        {
          style: 'tablefont',
          table: {
            body: [
              ['\nThis order was committed by ' + this.pdfDataObject.placedByName + ' on ' + orderCreateDate
                + ' (CST). If you have any questions regarding these changes, please contact WinField United Customer Service, 1-855-494-6343.'],
            ]
          },
          layout: 'noBorders'
        },
      ],
      styles: {
        pageText: {
          color: '#0b3f54',
        },
        header: {
          fontSize: 18,
          bold: true,
          margin: [0, 20, 0, 10],
          decoration: 'underline'
        },
        name: {
          fontSize: 16,
          bold: true
        },
        jobTitle: {
          fontSize: 14,
          bold: true,
          italics: true
        },
        sign: {
          margin: [0, 50, 0, 10],
          alignment: 'right',
          italics: true
        },
        tableHeader: {
          bold: true,
          fillColor: '#f5f4f2',
          fontSize: 8,
          color: '#0b3f54',
        },
        tablefont: {
          fontSize: 8,
          color: '#0b3f54'
        },
        tableUnit: {
          fontSize: 8,
          background: '#FDCF35',
          color: '#0b3f54'
        },
        tablePayment: {
          fontSize: 8,
          background: '#6fc8c0',
          color: '#0b3f54'
        }
      }
    };

    return pdfHTML;
  }

  getContractPdfObject(itemDetails) {
    const tblObject = [];
    const growerOrderDetails = itemDetails;
    const tbl = {
      table: {
        widths: ['25%', '15%', '10%', '10%', '10%', '10%', '10%', '10%'],
        color: '#0b3f54',
        body: [
          [
            { text: 'Product', style: 'tableHeader' },
            { text: 'Seed Size', style: 'tableHeader', alignment: 'center' },
            { text: 'Treatment', style: 'tableHeader', alignment: 'center' },
            { text: 'Package Size', style: 'tableHeader', alignment: 'center' },
            { text: 'Technology', style: 'tableHeader', alignment: 'center' },
            { text: 'Long/Short', style: 'tableHeader', alignment: 'center' },
            { text: 'Units', style: 'tableHeader', alignment: 'center' },
            { text: 'Delivery', style: 'tableHeader', alignment: 'center' }
          ],
          ...growerOrderDetails.map(cpp => {
            const formattedNumber = this.commonService.getFormatedNumberWithColour(cpp.longShortPosition);
            const textObject = {
              text: formattedNumber.value,
              alignment: 'center',
              color: formattedNumber.color
            };
            const productText = cpp.brand + "-" + cpp.marketingBrand;
            const nonReturnableText = "*NON-RETURNABLE";
            return [
              {
                stack: [
                  { text: productText, alignment: 'left' },
                  cpp.seedNonReturnable ? { text: nonReturnableText, color: 'red', alignment: 'left', fontSize: 10 } : {}
                ],
              },
              { text: cpp.seedSize, alignment: 'center' },
              { text: cpp.treatment, alignment: 'center' },
              { text: cpp.packageSize, alignment: 'center' },
              { text: cpp.technology, alignment: 'center' },
              { text: textObject.text, alignment: textObject.alignment, color: textObject.color },
              { text: cpp.geu, alignment: 'center' },
              { text: cpp.desiredDeliveryDate, alignment: 'center' }
            ];
          })
        ]
      },
      style: 'tablefont',
    };
    tblObject.push(tbl);
    return tblObject;
  }
}
